import {useEffect} from 'react'
import rtlPlugin from 'stylis-plugin-rtl'
import {CacheProvider} from '@emotion/react'
import createCache from '@emotion/cache'

const cacheRtl = createCache({
  key: 'rtl',
  stylisPlugins: [rtlPlugin]
})

const DirectionWrapper = ({children}: any) => {
  useEffect(() => {
    document.body.dir = 'rtl'
  }, [])

  return <CacheProvider value={cacheRtl}>{children}</CacheProvider>
}

export default DirectionWrapper
